import ComparePlansLink from 'pricing-pages-lib/components/ComparePlansLink';
import { LIMIT_USAGE } from 'pricing-pages-lib/constants/EarlyRequesterNames';
import LimitUsageSection from 'pricing-pages-ui-components/limit-usage/LimitUsageSection';
import { useSelector } from 'react-redux';
import { getPrimaryTracker } from 'usage-tracker-container';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import { productsFromProductInventorySelector } from '../../selectors/ProductInventorySelectors';
import RecommendedStarterFeatureTableContainer from './RecommendedStarterFeatureTableContainer';
import RecommendedStarterFooter from './RecommendedStarterFooter';
import RecommendedStarterHeaderBanner from './RecommendedStarterHeaderBanner';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RecommendedStarterCustomerPlatformContainer = () => {
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const ownedProducts = useSelector(state => {
    if (!hasPricingAndPurchasingSucceeded) return [];
    return productsFromProductInventorySelector(state);
  });
  const isFreePortal = hasPricingAndPurchasingSucceeded && ownedProducts && ownedProducts.length <= 0;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(RecommendedStarterHeaderBanner, {}), /*#__PURE__*/_jsx(ComparePlansLink, {}), /*#__PURE__*/_jsx(LimitUsageSection, {
      isFreePortal: isFreePortal,
      usageTracker: getPrimaryTracker(),
      earlyRequestName: LIMIT_USAGE
    }), /*#__PURE__*/_jsx(RecommendedStarterFeatureTableContainer, {}), /*#__PURE__*/_jsx(RecommendedStarterFooter, {})]
  });
};
export default RecommendedStarterCustomerPlatformContainer;